import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";

const DURATION = 3.1;

const Intro = ({ onDone }) => {
  const [show, setShow] = useState(true);

  useEffect(() => {
    const doneTimer = setTimeout(onDone, 2600);
    const hideTimer = setTimeout(() => setShow(false), 2800);
    return () => {
      clearTimeout(doneTimer);
      clearTimeout(hideTimer);
    };
  }, [onDone]);

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          data-testid="brand-intro"
          initial={{ opacity: 1 }}
          exit={{ opacity: 0, transition: { duration: 0.7, ease: [0.16, 1, 0.3, 1] } }}
          className="fixed inset-0 z-[100] flex items-center justify-center overflow-hidden bg-[#111111]"
        >
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: [0, 1, 1, 0] }}
            transition={{ duration: DURATION, times: [0, 0.22, 0.82, 1], ease: ["easeOut", "linear", "easeInOut"] }}
            className="relative w-44 sm:w-56 lg:w-64"
          >
            {/* Soft red backlight — strongest behind the mark, diffusing outward */}
            <motion.div
              aria-hidden
              initial={{ opacity: 0, scale: 0.92 }}
              animate={{
                opacity: [0, 0, 0.95, 0.8, 0.95, 0],
                scale: [0.92, 0.92, 1.03, 1, 1.03, 1.08],
              }}
              transition={{
                duration: DURATION,
                times: [0, 0.22, 0.44, 0.62, 0.85, 1],
                ease: ["linear", "easeOut", "easeInOut", "easeInOut", "easeIn"],
              }}
              className="absolute -inset-[55%] rounded-full blur-2xl"
              style={{
                background:
                  "radial-gradient(circle, rgba(232,34,45,0.55) 0%, rgba(232,34,45,0.28) 32%, rgba(232,34,45,0.1) 55%, transparent 75%)",
              }}
            />
            <img
              src="/assets/logo-mark-intro.png"
              alt="Devkii Electricals"
              className="relative w-full"
            />
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export { Intro };
